import { SliderProgressSize } from "@smartsuite/react-ui/lib/components/fields/Number/SliderProgress/SliderProgress.constants";

export const getSliderSize = (displayFormat: number): SliderProgressSize => {
  switch (displayFormat) {
    case 1:
      return "small";
    case 2:
      return "medium";
    case 3:
      return "large";
    default:
      return "medium";
  }
};
